import React from 'react'
import { useAtom, useSetAtom } from 'jotai'

import logo from '../../assets/logoCrediper_20Anni.svg'
import logo_mobile from '../../assets/logoMobile.svg'
import {
	activedStep,
	selectedValueAtom,
	selectedSubStepAtom,
	showSubStepAtom,
	disclaimerOpenAtom,
} from '@store/store'

import CloseIcon from '@ui/components/svg/ico_x'
import { IconBase } from '@ui/components/svg/IconBase'
import { _useSaveDataForm } from './simulatore-hooks'
import { StepsSimulatore } from '@store/stepsSimulatore'
import { SalvaOfferta } from './SalvaOfferta'
import { ExitModal } from './ExitModal'
import { dataStateAtom } from '@store/atoms'
import { affinityLogoAtom } from '@store/store'
import { useAffinityLogo } from '@hooks/useAffinityLogo'

// Generated by GitHub Copilot
/**
 * Header component for Simulatore pages.
 * @param hideBackButton - If true, hides the back button (for Thank You page, etc.)
 */
const Header = ({ hideBackButton = false, hideClose = false }: { hideBackButton?: boolean; hideClose?: boolean } = {}) => {
	const [activeStep, setActiveStep] = useAtom(activedStep)
	const [showSubStepMap, setShowSubStepMap] = useAtom(showSubStepAtom)
	const showSubStep = showSubStepMap[activeStep] ?? false

	const [state] = useAtom(dataStateAtom)
	const codiceAffinity = state.token?.StartingValues?.CodiceAffinity || state.data?.StartingValues?.CodiceAffinity
	const [affinityLogo] = useAtom(affinityLogoAtom)
	const { fetchLogo } = useAffinityLogo()

	// On mount, if a CodiceAffinity is already present (e.g. pre-set from token),
	// fetch its logo so the header shows the correct partner image.
	React.useEffect(() => {
		if (codiceAffinity && !affinityLogo) {
			fetchLogo(codiceAffinity)
		}
	}, [codiceAffinity]) // affinityLogo intentionally excluded to avoid re-fetch loop

	// Modale
	const [isModalOpen, setIsModalOpen] = React.useState(false)
	const closeModal = () => setIsModalOpen(false)
	const openModal = () => setIsModalOpen(true)

//set disclamer close on next 
	const setDisclaimerOpen = useSetAtom(disclaimerOpenAtom) 

	const handleBack = () => {

		 setDisclaimerOpen(false) //close disclamer on next
		if (showSubStepMap[activeStep]) {
			setShowSubStepMap((prev) => ({
				...prev,
				[activeStep]: false,
			}))
		} else if (activeStep > 1) {
			setActiveStep(activeStep - 1)
		}
	}

	return (
		<div className='flex flex-col md:gap-1 md:mb-3 sticky top-0 z-50 bg-white'>
			<div className='flex justify-between items-center py-2'>
				<div className='flex items-center gap-3'>
					<img src={logo_mobile} alt='logo mobile' className='block md:hidden' />
					<img src={logo} alt='logo desktop' className='hidden md:block' />
					{codiceAffinity && affinityLogo && (
						<>
							<span className='text-(--border-top) font-light text-xl'>|</span>
							<img src={affinityLogo} alt='logo affinity' className='h-6 md:h-8 w-auto object-contain' />
						</>
					)}
				</div>
				{!hideClose && (
					<div onClick={openModal}>
						<button
							className='
						group
						w-6 h-6 md:w-8 md:h-8
						border-[1.6px] md:border-[3.5px] 
						border-(--green-default)
    cursor-pointer
    flex items-center justify-center
    rounded-full
	text-base md:text-lg
    text-(--green-default)
    hover:bg-(--green-default)
    hover:text-white
  						'
						>
							<CloseIcon className='transition-transform duration-300' />
						</button>
					</div>
				)}
			</div>

			   <div className={`border-t border-t-(--border-top) gap-16 ${
			   !hideBackButton && (activeStep > StepsSimulatore.PROGETTO || showSubStep)
				   ? 'h-[45px] md:h-[57px] md:pt-4 md:pb-0 md:px-2 py-2.5'
				   : 'h-0 py-0'
		   }`}>
				   {!hideBackButton && (activeStep > StepsSimulatore.PROGETTO || showSubStep) && (
					   <button
						   className='
				  group
				   w-6 h-6 md:w-8 md:h-8
		flex items-center justify-center
		rounded-full
		border-2 border-(--green-default)
		bg-linear-to-r from-(--green-default) to-(--green-hover)
		text-white
		transition-all duration-300
		hover:from-white hover:to-white
		hover:text-(--green-default)
						   '
						   onClick={handleBack}
					   >
						   {/* ARROW LEFT ICON SVG */}
						   <IconBase
							   className='transition-transform duration-300'
							   icon='M14 6L8 12L14 18'
						   />
					   </button>
				   )}
			   </div>

			{isModalOpen && (
				<ExitModal
					isModalOpen={isModalOpen}
					closeModal={closeModal}
					tipo={1}
					action={2}
				/>
			)}
		</div>
	)
}
export default Header
